module.exports = __webpack_public_path__ + "img/home_img_phone@2x.404aeb64.png";